const axios = require('axios');

async function acceptCookies(url) {
    const {data} = await axios.post(url, {});
    return data;
}

export const CookiesService = {
    acceptCookies,
};

export default CookiesService;
